export const selectAudiences = (store) => store.audience.audiences;
export const selectJurists = (store) => store.audience.jurists;
export const selectMyAudiences = (store) => store.audience.myAudiences;
export const selectAudience = (store) => store.audience.audience;
export const selectAudienceErrors = (store) => store.audience.errorsInfo;
export const selectListAudienceLoading = (store) => store.audience.loadingState.list;
export const selectMyHearingDateLoading = (store) => store.audience.loadingState.myHearingDate;
export const selectZipLoading = (store) => store.audience.loadingState.zip;
